import type { Organization } from '@/types/organization.ts'
export type JsonPrimitive = string | number | boolean | null
export type JsonValue = JsonPrimitive | { [key: string]: JsonValue } | JsonValue[]

export type IopFormMessage = {
  id: number
  uuid: string
  status: 'FAILED' | 'SENT' | 'RECEIVED' | 'PROCESSED' | 'CONFLICT'
  communicationDirection: IopCommunicationDirection
  formVersion: number | null
  createdDate: string
  stroomSignatureUUID: string | null
  ritUUID: string | null
  form: JsonValue | null
  relations: Organization[]
  iopFormMessageOwner: Organization | null
  carrierEnterpriseNumbers: string[]
  ctbEnterpriseNumber: string | null
  treatmentFacilityEnterpriseNumber: string | null
  producerEnterpriseNumber: string | null
}

export type IopFormMessageError = {
  id: number
  createdDate: string
  lastModifiedDate: string
  createdBy: string
  extraOptions: Record<string, JsonValue>
  createdByOrganisation: number
  lastModifiedBy: string
  deleted: boolean
  syncindex: string
  owner: number | null
  uuid: string
  errorMessage: string
  communicationDirection: IopCommunicationDirection
}

export type ChangelogEntry = {
  previousValue: string | null
  currentValue: string
  changedByOrganizationUuid: string | null
  changedByOrganizationName: string | null
  changedByOrganizationEnterpriseNumber: string
  changedByUser: string
  changedOnTimestamp: string
  pdfFieldTitle: string
  sourceFormVersion: number
  changedByVatNumber: string
  operation: string
}

export enum IopCommunicationDirection {
  LZP_INCOMING = 'LZP_INCOMING',
  LZP_OUTGOING = 'LZP_OUTGOING',
}

export enum Operation {
  ADD = 'ADD',
  COPY = 'COPY',
  REPLACE = 'REPLACE',
  REMOVE = 'REMOVE',
  CONFLICT = 'CONFLICT',
  CONFLICT_RESOLUTION_NO_CHANGE = 'CONFLICT_RESOLUTION_NO_CHANGE',
  CONFLICT_RESOLUTION_KEEP_VERSION_RESPONSIBLE = 'CONFLICT_RESOLUTION_KEEP_VERSION_RESPONSIBLE',
  CONFLICT_RESOLUTION_ADD = 'CONFLICT_RESOLUTION_ADD',
  CONFLICT_RESOLUTION_REPLACE = 'CONFLICT_RESOLUTION_REPLACE',
}

export const operationMapping: Map<Operation, string> = new Map([
  [Operation.ADD, 'TOEVOEGEN'],
  [Operation.COPY, 'KOPIËREN'],
  [Operation.REPLACE, 'VERVANG'],
  [Operation.REMOVE, 'VERWIJDER'],
  [Operation.CONFLICT, 'CONFLICT'],
  [Operation.CONFLICT_RESOLUTION_NO_CHANGE, 'CONFLICT OPLOSSING (GEEN VERANDERING)'],
  [Operation.CONFLICT_RESOLUTION_KEEP_VERSION_RESPONSIBLE, 'CONFLICT OPLOSSING (BEHOU VERSIE)'],
  [Operation.CONFLICT_RESOLUTION_ADD, 'CONFLICT OPLOSSING (TOEVOEGEN)'],
  [Operation.CONFLICT_RESOLUTION_REPLACE, 'CONFLICT OPLOSSING (VERVANG)'],
])
